var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59885 11.1026V7.50352C7.59773 6.38785 8.0112 5.31155 8.75899 4.48358C9.50679 3.65561 10.5356 3.13503 11.6456 3.02291C12.7556 2.91079 13.8677 3.21511 14.766 3.87682C15.6642 4.53852 16.2846 5.51038 16.5066 6.60375M5.7993 11.1026H18.3961C19.39 11.1026 20.1957 11.9083 20.1957 12.9022V19.2006C20.1957 20.1944 19.39 21.0001 18.3961 21.0001H5.7993C4.80544 21.0001 3.99976 20.1944 3.99976 19.2006V12.9022C3.99976 11.9083 4.80544 11.1026 5.7993 11.1026Z",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlock);
export default __webpack_public_path__ + "static/media/icon-unlock.d2500c548348a7046b777030dd383de5.svg";
export { ForwardRef as ReactComponent };